import * as React from "react";
import Box from "@mui/material/Box";
import Grow from "@mui/material/Grow";
import Slide from "@mui/material/Slide";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import ConstructionIcon from "@mui/icons-material/Construction";
import AddIcon from "@mui/icons-material/Add";
import FormatPaintIcon from "@mui/icons-material/FormatPaint";
import FlashlightOnIcon from "@mui/icons-material/FlashlightOn";
import SellIcon from "@mui/icons-material/Sell";
import ChatIcon from "@mui/icons-material/Chat";
import TripOriginIcon from "@mui/icons-material/TripOrigin";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import {
  Card,
  CardContent,
  Button,
  CardActions,
  Snackbar,
} from "@mui/material";
import ColorPicker from "./ColorPicker";
import ArrowEdge from "./ArrowEdge";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import TextField from "@mui/material/TextField";

export default function Toolbox(add_node) {
  const [selectedColor, setSelectedColor] = React.useState("#000000");
  const [openToast, setOpenToast] = React.useState(false);

  const [checked, setChecked] = React.useState(false);
  const [showBoard, setShowBoard] = React.useState(false);

  const handleColorSelect = (color) => {
    setSelectedColor(color);
    // 更多的逻辑...
    console.log(`Color selected: ${color}`);
  };
  const [u, setU] = React.useState("");
  const [v, setV] = React.useState("");
  const generateCode = () => {
    navigator.clipboard.writeText(
      `set_edge_color(${u}, ${v},"${selectedColor}");`,
    );
    setOpenToast(true);
    setShowBoard(false);
  };

  const handleChange = () => {
    setChecked((prev) => !prev);
  };

  const add_actions = [
    { icon: <TripOriginIcon bgcolor="blue" />, name: "加入节点" },
    { icon: <ArrowRightAltIcon />, name: "加入边" },
  ];

  const color_actions = [
    { icon: <TripOriginIcon bgcolor="blue" />, name: "节点染色" },
    {
      icon: <ArrowRightAltIcon />,
      name: "边染色",
      onClick: () => {
        setShowBoard((prev) => !prev);
      },
    },
  ];

  return (
    <>
      <div>
        <Snackbar
          open={openToast}
          autoHideDuration={1000}
          message="已生成到剪贴板"
          onClose={(_, reason) =>
            reason === "clickaway" ? 0 : setOpenToast(false)
          }
          anchorOrigin={{
            horizontal: "center",
            vertical: "bottom",
          }}
        />

        <Slide direction="right" in={showBoard} mountOnEnter unmountOnExit>
          <Card
            style={{
              position: "absolute",
              bottom: 150,
              zIndex: 2000,
              height: 200,
              width: 500,
            }}
          >
            <CardContent>
              <div style={{ display: "flex" }}>
                <RadioButtonUncheckedIcon
                  style={{
                    fontSize: "40px",
                  }}
                ></RadioButtonUncheckedIcon>
                <div>
                  <ColorPicker
                    onSelect={handleColorSelect}
                    currentColor={selectedColor}
                  />
                </div>
                <RadioButtonUncheckedIcon
                  style={{
                    fontSize: "40px",
                  }}
                ></RadioButtonUncheckedIcon>
              </div>
              <div style={{ display: "flex", marginTop: "20px" }}>
                <TextField
                  id="outlined-basic"
                  label="u"
                  variant="outlined"
                  style={{ width: "120px" }}
                  value={u}
                  onChange={(e) => {
                    setU(e.target.value);
                  }}
                />
                <TextField
                  id="outlined-basic"
                  label="v"
                  variant="outlined"
                  style={{ width: "120px", marginLeft: "120px" }}
                  value={v}
                  onChange={(e) => {
                    setV(e.target.value);
                  }}
                />
              </div>
            </CardContent>
            <CardActions>
              <Button onClick={generateCode}>生成</Button>
              <Button
                onClick={() => {
                  setShowBoard((prev) => !prev);
                }}
              >
                取消
              </Button>
            </CardActions>
          </Card>
        </Slide>
      </div>

      <SpeedDial
        ariaLabel="SpeedDial example"
        sx={{
          position: "absolute",
          bottom: 80,
          left: 20,
          ".MuiSpeedDial-fab": {
            bgcolor: "orange",
          },
        }}
        icon={<SpeedDialIcon icon={<ConstructionIcon />} />}
        onClick={handleChange}
        onOpen={(_, r) => {
          r === "mouseEnter" && setChecked(true);
        }}
      />

      <Grow in={checked}>
        <SpeedDial
          ariaLabel="SpeedDial example"
          sx={{
            position: "absolute",
            bottom: 80,
            left: 100,
            ".MuiSpeedDial-fab": {
              bgcolor: "grey",
            },
          }}
          icon={<SpeedDialIcon icon={<AddIcon />} />}
        >
          {add_actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              onClick={action.onClick}
            />
          ))}
        </SpeedDial>
      </Grow>
      <Grow
        in={checked}
        style={{ transformOrigin: "0 0 0" }}
        {...(checked ? { timeout: 200 } : {})}
      >
        <SpeedDial
          ariaLabel="SpeedDial example"
          sx={{
            position: "absolute",
            bottom: 80,
            left: 180,
            ".MuiSpeedDial-fab": {
              bgcolor: selectedColor,
            },
          }}
          icon={<SpeedDialIcon icon={<FormatPaintIcon />} />}
        >
          {color_actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              onClick={action.onClick}
            />
          ))}
        </SpeedDial>
      </Grow>
      <Grow
        in={checked}
        style={{ transformOrigin: "0 0 0" }}
        {...(checked ? { timeout: 400 } : {})}
      >
        <SpeedDial
          ariaLabel="SpeedDial example"
          sx={{
            position: "absolute",
            bottom: 80,
            left: 260,
            ".MuiSpeedDial-fab": {
              bgcolor: "blue",
            },
          }}
          icon={<SpeedDialIcon icon={<FlashlightOnIcon />} />}
        />
      </Grow>

      <Grow
        in={checked}
        style={{ transformOrigin: "0 0 0" }}
        {...(checked ? { timeout: 600 } : {})}
      >
        <SpeedDial
          ariaLabel="SpeedDial example"
          sx={{
            position: "absolute",
            bottom: 80,
            left: 340,
            ".MuiSpeedDial-fab": {
              bgcolor: "grey",
            },
          }}
          icon={<SpeedDialIcon icon={<SellIcon />} />}
        />
      </Grow>

      <Grow
        in={checked}
        style={{ transformOrigin: "0 0 0" }}
        {...(checked ? { timeout: 800 } : {})}
      >
        <SpeedDial
          ariaLabel="SpeedDial example"
          sx={{
            position: "absolute",
            bottom: 80,
            left: 420,
            ".MuiSpeedDial-fab": {
              bgcolor: "grey",
            },
          }}
          icon={<SpeedDialIcon icon={<ChatIcon />} />}
        />
      </Grow>
    </>
  );
}
